import React, { memo,useEffect,useState }  from 'react';
import PropTypes from 'prop-types';
import TextInput from './TextInput';
import ReadOnlyField from './ReadOnlyField';
// import {setAndGetAttributes} from './FormInputFunctions';

const PickList = (props)=>{
  // Props Attr
   const {
    className,
    readOnly,
    disabled,
    value,
    style,
    options,
    additionalAttrs,
    name,
    required,
    appendClassName,
    defaultOptions,
    id,
    onBlur,
    statusBasedColor
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  // Handler
   const {
    changeHandler
  } = props;
  const optionsToRender = options.length > 0 ? options : defaultOptions;
    const onChangeHandler = (e)=>{
      changeHandler(e.target.value,{e});       
    } 
    // Get status-based background color
    const getStatusColor = (statusValue) => {
      if (!statusValue || !statusBasedColor) return null;
      const status = String(statusValue).toLowerCase().trim();
      // Not Started - Light Purple/Blue
      if (status === 'not started' || status === 'notstarted' || status === 'vstcompany01') {
        return { backgroundColor: '#E3E8FA', color: '#4A505C' }; 
      } 
      // Pending/Ordered - Yellow/Amber
      else if (status === 'pending' || status === 'ordered') {
         return { backgroundColor: '#F7F2E6', color: '#CA8B14' }; 
      } 
      // Passed/Normal/Completed - Green
      else if (status === 'passed' || status === 'normal' || status === 'completed' || status ==='administered' || status === 'dispensed' || status === 'PASSED' || status === 'NORMAL' || status === 'COMPLETED' || status === 'negative' || status === 'confirmed negative') {
        return { backgroundColor: '#d1fae5', color: '#065f46' }; 
      } 
      // Failed/Abnormal - Red
      else if (status === 'failed' || status === 'abnormal' || status === 'FAILED' || status === 'ABNORMAL' || status === 'positive' || status === 'confirmed positive' ||status === 'cancelled' || status === 'CANCELLED') {
        return { backgroundColor: '#fee2e2', color: '#991b1b' }; 
      }
      // Cancelled - Grey
      else if ( status === 'not administered') {
        return { backgroundColor: '#e5e7eb', color: '#4b5563' }; 
      } else {
        return { backgroundColor: '#F7F2E6', color: '#CA8B14' }; 
      }
      return null;
    };
    const statusStyle = !isFocused && getStatusColor(value);
    const combinedStyle = statusStyle ? { ...style, ...statusStyle } : style; 
    return(
      <>
        {
          readOnly==true ? //if readonly true show text field instead of picklist
          <ReadOnlyField {...props} options={options} />
            :
            <select
              className={className + ' ' + appendClassName}
              name={name}
              id={id}
              value={value}
              style={combinedStyle}
              {...additionalAttrs}
              readOnly={readOnly}
              required={required}
              disabled={disabled}
              onFocus={() => setIsFocused(true)}
              onBlur={(e) => {
                setIsFocused(false);
                if (onBlur) onBlur(e);
              }}
              onChange={(e) => onChangeHandler(e)} >
              {optionsToRender?.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

        }
      </>
      
    )
}

PickList.defaultProps = {
  isMandatory:false,
  required:false,
  className: 'form-control',
  appendClassName:'',
  placeholder:'',
  value:'',
  id:'',
  style:{},
  readOnly:false,
  disabled:false,
  options:[],
  defaultOptions:[{label:'-Select-',value:'-'}],
  additionalAttrs :{},
  validation:{
    isValid:true,message:''
  },
  onBlur:()=>{
  },

}
PickList.propTypes = {
  type: PropTypes.string,
  isMandatory: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  // validationRules: PropTypes.array,
  // valid: PropTypes.bool,
  changeHandler: PropTypes.func.isRequired,
};

export default memo(PickList);
